<template>
  <section class="section" id="register">
    <div class="section-inner">
      <div
        class="section-header reveal"
        :class="{ visible: revealed.header }"
        ref="header"
      >
        <div class="section-number">05 / REGISTER</div>
        <h2 class="section-title">参观报名</h2>
        <p class="section-desc">
          填写下方信息，完成预登记，届时凭二维码即可快速入场参观
        </p>
      </div>
      <div
        class="form-wrap reveal"
        :class="{ visible: revealed.body }"
        ref="body"
      >
        <form
          v-if="!showSuccess"
          id="registerForm"
          @submit.prevent="handleSubmit"
          novalidate
        >
          <div class="form-header">
            <h3>✦ 参观报名预登记 ✦</h3>
            <p>
              请认真填写以下信息，带
              <span class="required-star">*</span> 为必填项
            </p>
          </div>
          <div class="form-grid">
            <!-- 单位名称 -->
            <div class="form-group full-width">
              <label
                class="form-label"
                for="custom_868f44d1-f7e3-4759-bfd8-d87385f40060"
                >单位名称<span class="form-label-required">*</span></label
              >
              <input
                type="text"
                class="form-input"
                :class="{ error: errors.company }"
                id="custom_868f44d1-f7e3-4759-bfd8-d87385f40060"
                v-model="form.company"
                placeholder="请输入您所在的单位/机构名称"
                @blur="validateField('company')"
                @input="onInput('company')"
              />
              <div class="form-error-text" :class="{ visible: errors.company }">
                请输入单位名称
              </div>
            </div>

            <!-- 姓名 -->
            <div class="form-group">
              <label class="form-label" for="name"
                >姓名<span class="form-label-required">*</span></label
              >
              <input
                type="text"
                class="form-input"
                :class="{ error: errors.name }"
                id="name"
                v-model="form.name"
                placeholder="请输入您的真实姓名"
                @blur="validateField('name')"
                @input="onInput('name')"
              />
              <div class="form-error-text" :class="{ visible: errors.name }">
                请输入姓名
              </div>
            </div>

            <!-- 手机 -->
            <div class="form-group">
              <label class="form-label" for="mobile"
                >手机<span class="form-label-required">*</span></label
              >
              <div class="form-input-wrap">
                <input
                  type="tel"
                  class="form-input"
                  :class="{ error: errors.mobile }"
                  id="mobile"
                  v-model="form.mobile"
                  placeholder="请输入11位手机号码"
                  maxlength="11"
                  ref="mobile"
                  @blur="validateField('mobile')"
                  @input="onInput('mobile')"
                />
                <button
                  type="button"
                  class="form-code-btn"
                  :class="{ counting: timeShow }"
                  :disabled="codeBtnDisabled"
                  @click="handleGetCode"
                >
                  {{ codeBtnText }}
                </button>
              </div>
              <div class="form-error-text" :class="{ visible: errors.mobile }">
                请输入正确的11位手机号码
              </div>
            </div>

            <!-- 验证码 -->
            <div class="form-group">
              <label class="form-label" for="code"
                >验证码<span class="form-label-required">*</span></label
              >
              <input
                type="text"
                class="form-input"
                :class="{ error: errors.code }"
                id="code"
                v-model="form.code"
                placeholder="请输入短信验证码"
                maxlength="6"
                @blur="validateField('code')"
                @input="onInput('code')"
              />
              <div class="form-error-text" :class="{ visible: errors.code }">
                请输入验证码
              </div>
            </div>

            <!-- 参与活动（可多选） -->
            <div class="form-group full-width">
              <label class="form-label"
                >参与活动（可多选）<span class="form-label-required"
                  >*</span
                ></label
              >
              <div
                class="checkbox-grid"
                :class="{ error: errors.activities }"
                role="listbox"
              >
                <label
                  v-for="opt in activityOptions"
                  :key="opt.value"
                  class="checkbox-grid-item"
                  :class="{
                    selected: selectedActivities.includes(opt.value),
                  }"
                >
                  <input
                    type="checkbox"
                    :value="opt.value"
                    v-model="selectedActivities"
                    @change="onActivitiesChange"
                    class="checkbox-grid-native"
                  />
                  <span class="checkbox-grid-box">
                    <svg viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </span>
                  <span class="checkbox-grid-label">{{ opt.label }}</span>
                </label>
              </div>
              <div
                class="form-error-text"
                :class="{ visible: errors.activities }"
              >
                请至少选择一项参与活动
              </div>
            </div>
          </div>
          <div class="form-submit">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              <template v-if="submitting"
                >提交中… <span class="btn-arrow">⟳</span></template
              >
              <template v-else
                >提交报名 <span class="btn-arrow">→</span></template
              >
            </button>
          </div>
        </form>
        <div v-else class="form-success visible">
          <div class="form-success-icon">
            <svg viewBox="0 0 24 24">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <h4>报名成功！</h4>
          <p class="form-success-desc">
            感谢您的报名！请保存下方二维码，<br />届时凭二维码即可在展会现场快速入场。期待与您相见！
          </p>
          <div v-if="qrTicket" class="form-qr-wrap">
            <div class="form-qr-card">
              <img :src="qrTicket" alt="入场二维码" class="form-qr-img" />
            </div>
            <p class="form-qr-tip">截图保存二维码，入场时出示即可</p>
            <!-- <a
              v-if="qrUrl"
              :href="qrUrl"
              target="_blank"
              rel="noopener"
              class="form-qr-link"
            >查看电子入场券 →</a> -->
          </div>
          <button class="btn btn-secondary" @click="resetForm">继续报名</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  sendCaptchaCode,
  makeVerifyToken,
  submitAttendee,
  CAPTCHA_APP_ID,
  getcustomizeinfo,
} from "../api";

const MAX_CODE_TIME = 120; // 与参考 verification-code.mixin 保持一致
const PHONE_RE = /^1[3-9]\d{9}$/;

export default {
  name: "RegisterForm",
  data() {
    return {
      form: { company: "", name: "", mobile: "", code: "" },
      selectedActivities: [],
      activityOptions: [],
      errors: {
        company: false,
        name: false,
        mobile: false,
        code: false,
        activities: false,
      },
      // 倒计时状态（对齐参考 verification-code.mixin 语义）
      timeShow: false,
      codeTime: MAX_CODE_TIME,
      timer: null,
      submitting: false,
      showSuccess: false,
      qrTicket: "",
      qrUrl: "",
      revealed: { header: false, body: false },
      observer: null,
    };
  },
  computed: {
    codeBtnText() {
      return this.timeShow ? `${this.codeTime} S` : "获取验证码";
    },
    codeBtnDisabled() {
      return this.timeShow || this.submitting;
    },
  },
  methods: {
    validateField(field) {
      const value = (this.form[field] || "").trim();
      if (field === "mobile") {
        this.errors.mobile = !PHONE_RE.test(value);
      } else if (field === "code") {
        // 腾讯云短信验证码一般 4~6 位
        this.errors.code = value.length < 4;
      } else {
        this.errors[field] = !value;
      }
    },
    onInput(field) {
      if (this.errors[field]) this.validateField(field);
    },
    async handleGetCode() {
      // 1. 校验手机号
      const mobile = (this.form.mobile || "").trim();
      if (!PHONE_RE.test(mobile)) {
        this.errors.mobile = true;
        if (this.$refs.mobile) this.$refs.mobile.focus();
        alert("请输入正确的手机号");
        return;
      }

      // 2. 调腾讯云滑动验证
      if (typeof window.TencentCaptcha !== "function") {
        alert("腾讯云验证尚未加载，请刷新页面后重试");
        return;
      }

      try {
        const { randstr, ticket } = await this.openTencentCaptcha();
        // 3. 通过滑动：调接口发短信
        const res = await sendCaptchaCode({
          mobile,
          Randstr: randstr,
          ticket,
        });
        if (res.success) {
          this.form.code = "";
          this.startCountdown();
        } else {
          alert(res.msg || "验证码发送失败，请稍后重试");
        }
      } catch (e) {
        // 用户取消滑动验证时不弹错误
        if (e && e.canceled) return;
        console.error("腾讯滑动验证失败", e);
        alert("验证失败，请稍后重试");
      }
    },
    /** 打开腾讯云滑动验证，返回 {randstr, ticket} 或在取消时抛 {canceled:true} */
    openTencentCaptcha() {
      return new Promise((resolve, reject) => {
        try {
          // eslint-disable-next-line no-undef
          const captcha = new TencentCaptcha(
            CAPTCHA_APP_ID,
            (response) => {
              // 用户通过验证：0 表示成功回调
              if (response && response.ticket && response.randstr) {
                resolve({ randstr: response.randstr, ticket: response.ticket });
              } else {
                reject({ canceled: true });
              }
              // captcha.show 回调结束后 SDK 会自动销毁；保险起见调用 destroy
              if (captcha && typeof captcha.destroy === "function") {
                try {
                  captcha.destroy();
                } catch (_) {}
              }
            },
            // 可选 options：https://cloud.tencent.com/document/product/1110/36841#.E5.8F.82.E6.95.B0
            {}
          );
          captcha.show();
        } catch (err) {
          reject(err);
        }
      });
    },
    /** 倒计时（与 verification-code.mixin 保持一致，120s） */
    startCountdown() {
      let time = MAX_CODE_TIME;
      this.timeShow = true;
      this.codeTime = time;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        time--;
        if (time <= 0) {
          time = 0;
          clearInterval(this.timer);
          this.timer = null;
          this.timeShow = false;
        }
        this.codeTime = time;
      }, 1000);
    },
    onActivitiesChange() {
      this.errors.activities = this.selectedActivities.length === 0;
    },
    async handleSubmit() {
      console.log(this.selectedActivities);

      // 1. 必填校验
      this.validateField("company");
      this.validateField("name");
      this.validateField("mobile");
      this.validateField("code");
      this.errors.activities = this.selectedActivities.length === 0;

      if (
        this.errors.company ||
        this.errors.name ||
        this.errors.mobile ||
        this.errors.code ||
        this.errors.activities
      ) {
        const firstError = document.querySelector("#registerForm .error");
        if (firstError && firstError.scrollIntoView) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        alert("请检查信息是否完整");
        return;
      }

      const mobile = this.form.mobile.trim();
      const code = this.form.code.trim();

      this.submitting = true;
      try {
        // 2. 校验验证码，换取 token
        const verifyRes = await makeVerifyToken({ mobile, code });
        if (!verifyRes.success || !verifyRes.token) {
          alert(verifyRes.msg || "短信验证码校验失败");
          return;
        }

        // 3. 提交报名（字段对齐 visit-registration.vue：code 不传，verify 换 token 后不再需要）
        const res = await submitAttendee({
          token: verifyRes.token,
          company: this.form.company.trim(),
          name: this.form.name.trim(),
          mobile,
          activities: this.selectedActivities,
        });
        if (res.success) {
          this.qrTicket = (res.data && res.data.ticket) || "";
          this.qrUrl = (res.data && res.data.url) || "";
          this.showSuccess = true;
        } else {
          alert(res.msg || "提交失败，请稍后重试");
        }
      } catch (err) {
        console.error(err);
        alert("网络异常，请检查网络后重试");
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.form = { company: "", name: "", mobile: "", code: "" };
      this.selectedActivities = [];
      this.errors = {
        company: false,
        name: false,
        mobile: false,
        code: false,
        activities: false,
      };
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timeShow = false;
      this.codeTime = MAX_CODE_TIME;
      this.submitting = false;
      this.showSuccess = false;
      this.qrTicket = "";
      this.qrUrl = "";
    },
    setupReveal() {
      if (typeof IntersectionObserver === "undefined") {
        this.revealed.header = true;
        this.revealed.body = true;
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (entry.target === this.$refs.header)
                this.revealed.header = true;
              if (entry.target === this.$refs.body) this.revealed.body = true;
            }
          });
        },
        { threshold: 0.12 }
      );
      if (this.$refs.header) this.observer.observe(this.$refs.header);
      if (this.$refs.body) this.observer.observe(this.$refs.body);
    },
    async getRegistrationTemplate() {
      const res = await getcustomizeinfo();
      if (res.success) {
        if (res?.data && res.data?.attendee_sign2) {
          const registrationTemplate = JSON.parse(res.data.attendee_sign2);
          registrationTemplate.map((item) => {
            if (item.type === "select") {
              const list = item.list || [];

              this.activityOptions = list.map((l) => {
                return {
                  value: l,
                  label: l,
                };
              });
            }
          });
        }
      }
    },
  },
  mounted() {
    this.$nextTick(this.setupReveal);
    this.getRegistrationTemplate();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style scoped>
.required-star {
  color: var(--color-error);
}

/* ====== Section common ====== */
.section {
  padding: 120px 32px;
  position: relative;
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 72px;
}

.section-number {
  display: inline-block;
  font-family: var(--font-serif);
  font-size: 14px;
  color: var(--color-primary);
  font-weight: 700;
  letter-spacing: 3px;
  margin-bottom: 16px;
  position: relative;
  padding: 0 40px;
}

.section-number::before,
.section-number::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 30px;
  height: 1px;
  background: var(--color-primary-light);
}

.section-number::before {
  left: 0;
}
.section-number::after {
  right: 0;
}

.section-title {
  font-family: var(--font-serif);
  font-weight: 900;
  font-size: clamp(32px, 4vw, 48px);
  color: var(--color-text);
  margin-bottom: 16px;
  line-height: 1.2;
}

.section-desc {
  font-size: 16px;
  color: var(--color-text-light);
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.8;
}

.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

/* ====== Button ====== */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 16px 32px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-primary {
  background: linear-gradient(
    135deg,
    var(--color-grad-start),
    var(--color-grad-end)
  );
  color: white;
  box-shadow: 0 8px 24px rgba(184, 69, 31, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(184, 69, 31, 0.4);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: var(--color-white);
  color: var(--color-text);
  border: 1.5px solid var(--color-border);
}

.btn-secondary:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
  background: var(--color-primary-light);
}

.btn-arrow {
  transition: transform 0.3s ease;
}

.btn-primary:hover .btn-arrow {
  transform: translateX(4px);
}

/* ====== 参观报名 Form Section ====== */
/* 下拉展开时，让 section（#register）整体层级高于后续 footer。
   因为 section 与 footer 是 .home 下的同级兄弟，DOM 顺序 footer 在后，
   不提升 z-index 时，溢出 section 的下拉菜单会被 footer 覆盖。 */
.section.section-above {
  z-index: 20;
}

.form-wrap {
  max-width: 860px;
  margin: 0 auto;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 56px;
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-lg);
  position: relative;
}

.form-wrap::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  /* 补回顶部圆角，防止去掉 overflow 后直角露出破坏圆角效果 */
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  background: linear-gradient(
    90deg,
    var(--color-primary),
    var(--color-accent),
    var(--color-primary)
  );
}

.form-header {
  text-align: center;
  margin-bottom: 48px;
}

.form-header h3 {
  font-family: var(--font-serif);
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 12px;
  color: var(--color-text);
}

.form-header p {
  font-size: 14px;
  color: var(--color-text-light);
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.form-group {
  position: relative;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

/* Input with button (verification code) */
.form-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.form-input-wrap .form-input {
  padding-right: 120px;
}

.form-code-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  padding: 8px 16px;
  background: linear-gradient(
    135deg,
    var(--color-grad-start),
    var(--color-grad-end)
  );
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  font-family: inherit;
  min-width: 100px;
  text-align: center;
}

.form-code-btn:hover:not(:disabled) {
  opacity: 0.9;
  box-shadow: 0 4px 12px rgba(237, 123, 26, 0.3);
}

.form-code-btn:disabled {
  background: #d5c5b8;
  color: #8e8278;
  cursor: not-allowed;
}

.form-code-btn.counting {
  background: #f0e0cc;
  color: #9a8d84;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 10px;
}

.form-label-required {
  color: var(--color-error);
  margin-left: 4px;
}

.form-input,
.form-select {
  width: 100%;
  padding: 14px 18px;
  background: var(--color-bg);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-size: 15px;
  color: var(--color-text);
  font-family: inherit;
  transition: all 0.3s ease;
  outline: none;
}

.form-input::placeholder {
  color: var(--color-text-muted);
}

.form-input:hover,
.form-select:hover {
  border-color: var(--color-primary-light);
}

.form-input:focus,
.form-select:focus {
  border-color: var(--color-primary);
  background: var(--color-white);
  box-shadow: 0 0 0 4px rgba(184, 69, 31, 0.1);
}

.form-input.error,
.form-select.error {
  border-color: var(--color-error);
  background: rgba(192, 57, 43, 0.04);
}

.form-error-text {
  font-size: 12px;
  color: var(--color-error);
  margin-top: 6px;
  display: none;
}

.form-error-text.visible {
  display: block;
}

/* 参与活动：原生 checkbox 网格列表（彻底避免下拉被裁切） */
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
  padding: 18px;
  background: var(--color-bg);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-sm);
  transition: all 0.3s ease;
}

.checkbox-grid.error {
  border-color: var(--color-error);
  background: rgba(192, 57, 43, 0.04);
}

.checkbox-grid-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: var(--color-text);
  user-select: none;
}

.checkbox-grid-item:hover {
  border-color: var(--color-primary-light);
  background: #fffbf6;
}

.checkbox-grid-item.selected {
  border-color: var(--color-primary);
  background: rgba(184, 69, 31, 0.06);
  box-shadow: 0 0 0 3px rgba(184, 69, 31, 0.08);
}

.checkbox-grid-native {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.checkbox-grid-box {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border: 2px solid var(--color-border);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: var(--color-white);
}

.checkbox-grid-item.selected .checkbox-grid-box {
  background: var(--color-primary);
  border-color: var(--color-primary);
}

.checkbox-grid-box svg {
  width: 12px;
  height: 12px;
  stroke: white;
  fill: none;
  stroke-width: 2.5;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.checkbox-grid-item.selected .checkbox-grid-box svg {
  opacity: 1;
}

.checkbox-grid-label {
  flex: 1;
  min-width: 0;
  line-height: 1.4;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.form-submit {
  text-align: center;
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px dashed var(--color-border);
}

.form-submit .btn {
  padding: 18px 56px;
  font-size: 16px;
}

.form-success {
  display: none;
  text-align: center;
  padding: 48px 24px;
}

.form-success.visible {
  display: block;
  animation: fadeIn 0.5s ease;
}

.form-success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, var(--color-success), #3a7a4e);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: successPop 0.6s ease;
}

@keyframes successPop {
  0% {
    transform: scale(0);
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.form-success-icon svg {
  width: 40px;
  height: 40px;
  stroke: white;
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
}

.form-success h4 {
  font-family: var(--font-serif);
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 10px;
  color: var(--color-text);
}

.form-success p {
  font-size: 15px;
  color: var(--color-text-light);
  margin-bottom: 24px;
  line-height: 1.8;
}

.form-qr-wrap {
  margin: 0 auto 28px;
  max-width: 260px;
}

.form-qr-card {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: var(--shadow-sm);
}

.form-qr-img {
  width: 100%;
  max-width: 220px;
  height: auto;
  display: block;
}

.form-qr-tip {
  font-size: 13px;
  color: var(--color-text-muted);
  margin-bottom: 12px;
}

.form-qr-link {
  display: inline-block;
  font-size: 14px;
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
  padding: 8px 16px;
  background: var(--color-primary-light);
  border-radius: 999px;
  transition: all 0.3s ease;
}

.form-qr-link:hover {
  background: var(--color-primary);
  color: white;
}

@media (max-width: 968px) {
  .section {
    padding: 80px 24px;
  }
}

@media (max-width: 640px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-wrap {
    padding: 32px 20px;
  }
  .btn {
    justify-content: center;
  }
  .checkbox-grid {
    grid-template-columns: 1fr;
    padding: 14px;
    gap: 10px;
  }
  .checkbox-grid-item {
    padding: 10px 12px;
    font-size: 13px;
  }
}
</style>
